import axios from '@axios'
import { useApiAWS } from '@/composables/useApi'

const api = useApiAWS()

export default {
  namespaced: true,
  state: {
    tabela_precos_item: {
      item_nome: '',
      item_descricao: 'F',
      id_categoria: '',
      ativo: null,
      tabela_precos_item: [],
    },
    tabela_precos_items: [],
  },
  getters: {
    GET_ITEMS(state) {
      return state.items
    },
  },
  mutations: {
    SET_PRODUTO_DATA(state, cliente) {
      state.cliente = cliente
    },
  },
  actions: {
    createImageItem(ctx, formData) {
      return new Promise((resolve, reject) => {
        axios
          .post('/tabela-precos-item', formData)
          .then(response => resolve(response))
          .catch(error => reject(error.response.data.message))
      })
    },
    update(ctx, { formData }) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/tabela-precos-item/${formData.id}`, formData)
          .then(response => resolve(response))
          .catch(error => reject(error.response.data.message))
      })
    },
    findAll(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/tabela-precos-item', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error.response.data.message))
      })
    },
    findById(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/tabela-precos-item/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error.response.data.message))
      })
    },
    delete(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/tabela-precos-item/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error.response.data.message))
      })
    },
    create(ctx, categoryData) {
      return new Promise((resolve, reject) => {
        axios
          .post('/tabela-precos-item', categoryData)
          .then(response => resolve(response))
          .catch(error => reject(error.response.data.message))
      })
    },
  },
}
